import React, { useEffect, useState } from 'react';
import { isWrongInput } from 'utils/helperMethods';
import Textbox from '../TextBox';
import DisplayName from './display-name';

interface IInputDisplayProps {
    inputValue: string; // Input field value
    defaultDisplayName: string; // Default text to be visible on page load
    maxCharacter: number; // Max character that can is allowed
    maxLengthValidationMessage: string; // Validation message to be shown on exceeding max character limit
    minLengthValidationMessage?: string; // Validation message to be shown on matching the min character limit
    textChangeHandler?: (value: string) => void; // On change event from input box
    alreadyExist?: boolean; // if value already exist
    alreadyExistMessage?: string; // Message to display if the value already exist
    minCharacter?: number; // Minimum character that is needed
    disable?: boolean; // disable edit
    onApplyHandler?: Function;
    showLoader?: boolean;
    disableBlur?: boolean;
}

const InputDisplay = (props: IInputDisplayProps) => {
    const {
        inputValue,
        defaultDisplayName,
        maxCharacter,
        minCharacter = 3,
        maxLengthValidationMessage,
        textChangeHandler,
        alreadyExist,
        alreadyExistMessage,
        minLengthValidationMessage = '',
        disable = false,
        onApplyHandler,
        showLoader = false,
        disableBlur,
    } = props;
    const [showTextbox, setShowTextbox] = useState(false);
    const [value, setValue] = useState(inputValue);
    const [displayName, setDisplayName] = useState(defaultDisplayName);

    useEffect(() => {
        if (disableBlur) setShowTextbox(false);
        setDisplayName(defaultDisplayName);
    }, [defaultDisplayName]);

    useEffect(() => {
        setValue(inputValue);
    }, [inputValue]);

    const onEditName = () => {
        setShowTextbox(true);
    };

    const onApplyChange = () => {
        if (isWrongInput(value) || alreadyExist || value.length > maxCharacter || value.length < minCharacter) {
            return;
        }
        if (!disableBlur) setShowTextbox(false);
        setDisplayName(value);
        if (value === '') {
            setDisplayName(defaultDisplayName);
        }
        if (typeof onApplyHandler === 'function') {
            onApplyHandler(value);
        }
    };

    const onCancel = () => {
        setShowTextbox(false);
        setValue(inputValue);
    };

    const errorMessage = () => {
        if (value.length > maxCharacter) {
            return maxLengthValidationMessage;
        }
        if (value.length < minCharacter) {
            return minLengthValidationMessage;
        }
        if (alreadyExist) {
            return alreadyExistMessage;
        }
        return '*These characters cannot be used: ` ; \' " < . \\';
    };

    const onTextChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        if (event.target.value !== ' ') {
            setValue(event.target.value);
        }
        textChangeHandler && textChangeHandler(event.target.value);
    };

    return showTextbox ? (
        <Textbox
            value={value}
            onChange={(event: React.ChangeEvent<HTMLInputElement>) => onTextChange(event)}
            onApplyChange={onApplyChange}
            textBoxValidation={value?.length > maxCharacter || value?.length < minCharacter || false}
            errorText={errorMessage()}
            maxLength={maxCharacter + 1}
            alreadyExist={alreadyExist}
            disableBlur={disableBlur}
            showLoader={showLoader}
            onCancel={onCancel}
        />
    ) : (
        <DisplayName
            displayName={displayName}
            onEditName={onEditName}
            value={value}
            disableEdit={disable}
            showLoader={showLoader}
        />
    );
};

export default InputDisplay;
